import { render, staticRenderFns } from "./ControllerRecord.vue?vue&type=template&id=71582af2&"
import script from "./ControllerRecord.vue?vue&type=script&lang=js&"
export * from "./ControllerRecord.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports